var exports = {
  "g4": "InviteModal.module__loadingContainer___aElkTW",
  "qy": "InviteModal.module__channelSubtitle___aElkTW",
  "HA": "InviteModal.module__channelName___aElkTW",
  "p": "InviteModal.module__channelIcon___aElkTW",
  "ak": "InviteModal.module__inviteButton___aElkTW",
  "UW": "InviteModal.module__warningContainer___aElkTW",
  "QW": "InviteModal.module__warningIcon___aElkTW",
  "i4": "InviteModal.module__warningText___aElkTW",
  "xr": "InviteModal.module__expirationText___aElkTW",
  "bv": "InviteModal.module__editLink___aElkTW",
  "Wm": "InviteModal.module__detailedView___aElkTW",
  "WT": "InviteModal.module__noChannelContent___aElkTW",
  "Q9": "InviteModal.module__noChannelIcon___aElkTW",
  "E_": "InviteModal.module__noChannelText___aElkTW",
};

module.exports = exports;
